import request from '@/utils/request'

// 获取验证码
export function sendVerifCode(data) {
  return request({
    url: `authCode`,
    method: 'post',
    data: data
  })
}

export function checkoutVerifCode(data) {
  return request({
    url: '/authCodeSuccess',
    method: 'post',
    data: data
  })
}

export function modifyUserPwd(data) {
  return request({
    url: '/merchant-api/merchantUser/modifyOwnPassword',
    method: 'post',
    data: data
  })
}

export function sendPasswordAuthCode(params) {
  return request({
    url: '/merchant-api/merchantUser/sendAuthCode',
    method: 'get',
    params
  })
}

export function fetchMerchantUsers(data) {
  return request({
    url: '/merchant-api/mch/system/getMchUserList',
    method: 'post',
    data
  })
}

export function addMerchantUser(data) {
  return request({
    url: '/merchant-api/merchantUser/addUser',
    method: 'post',
    data
  })
}

export function updateMerchantUserPwd(data) {
  return request({
    url: '/merchant-api/merchantUser/modifyPassword',
    method: 'post',
    data
  })
}

export function updateUserAuthorizedStatus(data) {
  return request({
    url: '/merchant-api/merchantUser/switchOnOff',
    method: 'post',
    data
  })
}

export function updateUserAuthorities(data) {
  return request({
    url: '/mchUser/role/authorities',
    method: 'post',
    data
  })
}

export function simulationStaticPayment(data) {
  return request({
    url: '/merchant-api/simulation/payment',
    method: 'post',
    data
  })
}

export function simulationDynamicPayment(data) {
  return request({
    url: '/merchant-api/simulation/payment/dynamic',
    method: 'post',
    data
  })
}

export function simulationDynamicRefund(data) {
  return request({
    url: '/merchant-api/simulation/refund',
    method: 'post',
    data
  })
}

export function simulationDisbursement(data) {
  return request({
    url: '/merchant-api/simulation/payout',
    method: 'post',
    data
  })
}

export function simulationCheckoutPayment(data) {
  return request({
    url: '/merchant-api/simulation/payment/checkout',
    method: 'post',
    data
  })
}

export function simulatePayToken(data) {
  return request({
    url: '/merchant-api/simulation/callback/payToken',
    method: 'post',
    data
  })
}

export function unlockMchUser(data) {
  return request({
    url: '/mchUser/unlock',
    method: 'post',
    data
  })
}

export function resetMFA(data) {
  return request({
    url: '/merchant-api/merchantUser/mfa-reset',
    method: 'post',
    data
  })
}

export function changeMFAStatus(data) {
  return request({
    url: '/merchant-api/merchantUser/mfa-change-status',
    method: 'post',
    data
  })
}

export function fetchMerchantRoles(data) {
  return request({
    url: '/merchant-api/mch/system/mchRoleList',
    method: 'post',
    data
  })
}

export function assignRoleAuthorities(data) {
  return request({
    url: '/merchant-api/mch/system/updateUserRoleAuth',
    method: 'post',
    data
  })
}

export function addMerchantRole(data) {
  return request({
    url: '/merchant-api/mch/system/addRoleAuth',
    method: 'post',
    data
  })
}

export function updateMchRole(data) {
  return request({
    url: '/merchant-api/mch/system/updateRoleAuth',
    method: 'post',
    data
  })
}

export function fetchMchMenuList(data) {
  return request({
    url: '/merchant-api/mch/system/getMchMenuList',
    method: 'post',
    data
  })
}

export function updateWithdrawType(data) {
  return request({
    url: '/merchant-api/mch/businessConfig/updateWithdrawType',
    method: 'post',
    data
  })
}

/**
 * 获取提现手续费
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchWithdrawFee(params) {
  return request({
    url: '/merchant-api/mchWithdraw/getWithdrawFee',
    method: 'get',
    params
  })
}

/**
 * 获取自动提现银行卡
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchSettlementBank(params) {
  return request({
    url: '/merchant-api/merchant/bank/checkSpecial/getSettlementBank',
    method: 'get',
    params
  })
}

/**
 * 获取商户提现类型
 * */
export function fetchWithdrawType(params) {
  return request({
    url: '/merchant-api/mch/businessConfig/getWithdrawType',
    method: 'get',
    params
  })
}

export function fetchNeedSupplementStatus(params) {
  return request({
    url: '/merchant-api/mch/businessConfig/getNeedSupplementStatus',
    method: 'get',
    params
  })
}

// notify_type = 1：商户结算银行审核信息通知
export function fetchtNotify(params) {
  return request({
    url: '/merchant-api/merchant/notify/getNotify',
    method: 'get',
    params
  })
}

export function closeNotify(data) {
  return request({
    url: '/merchant-api/merchant/notify/closeNotify',
    method: 'post',
    data
  })
}

export function fetchWithdrawStatus(params) {
  return request({
    url: '/merchant-api/mch/businessStatus/get',
    method: 'get',
    params
  })
}

// 获取商户通知设置
export function getMchNotifySetting(data) {
  return request({
    url: '/merchant-api/notify/getMchNotifySetting',
    method: 'post',
    data
  })
}

// 修改余额预警通知的余额预警规则
export function updateBalanceWarning(data) {
  return request({
    url: '/merchant-api/notify/updateBalanceWarning',
    method: 'post',
    data
  })
}

// 测试发送邮件
export function testSendEmail(data) {
  return request({
    url: '/merchant-api/notify/testSendEmail',
    method: 'post',
    data
  })
}

// 修改配置状态
export function updateMchNotifySetting(data) {
  return request({
    url: '/merchant-api/notify/updateMchNotifySetting',
    method: 'post',
    data
  })
}

// 通知信息
export function fetchNotificationPage(data) {
  return request({
    url: '/merchant-api/mch/listDownPanelNotice',
    method: 'post',
    data
  })
}

// 通知信息分页
export function fetchNotificationPageAll(data) {
  return request({
    url: '/merchant-api/mch/pageNotice',
    method: 'post',
    data
  })
}

export function deleteMchUserNotification(params) {
  return request({
    url: '/merchant-api/mch-user-notification/delete-mch-user-notification',
    method: 'delete',
    params
  })
}

export function fetchUnreadNotificationCount(params) {
  return request({
    url: '/merchant-api/mch/noticeBellInfo',
    method: 'get',
    params
  })
}

export function fetchNotificationDetail(data) {
  return request({
    url: `/merchant-api/mch/detailNotice`,
    method: 'post',
    data
  })
}

export function markNoticeAsRead(data) {
  return request({
    url: '/merchant-api/mch/markNoticeAsRead',
    method: 'post',
    data
  })
}

// 获取通知配置设置
export function fetchNoticeSetting(data) {
  return request({
    url: '/merchant-api/mch/detailNoticeSetting',
    method: 'post',
    data
  })
}

// 更新通知配置设置
export function updateNoticeSetting(data) {
  return request({
    url: '/merchant-api/mch/updateNoticeSetting',
    method: 'post',
    data
  })
}

// 更新余额预警金额
export function updateNoticeBalanceWarnAmount(data) {
  return request({
    url: '/merchant-api/mch/updateNoticeBalanceWarnAmount',
    method: 'post',
    data
  })
}

// 发送测试通知
export function sendTestNotice(data) {
  return request({
    url: '/merchant-api/mch/sendTestNotice',
    method: 'post',
    data
  })
}

// edit withdraw end
